import { Badge, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTableTranslation } from '@hero/molecules';

import * as S from './style';

function SecondHead({ globalFilters, onFilterChange }) {
  const translation = useTableTranslation();
  const { t } = useTranslation();

  const hasAnyFilter =
    !!globalFilters?.filters?.source?.length ||
    !!globalFilters?.filters?.status?.length ||
    !!globalFilters?.filters?.createdBy;

  return (
    hasAnyFilter && (
      <S.SubtitleWrapper>
        <Typography variant="caption1">{`${t(translation.filteredWithText)}:`}</Typography>
        {globalFilters.filters?.source?.map(filter => (
          <Badge
            color="bgDefault"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status,
                source: globalFilters.filters.source.filter(f => f.value !== filter.value),
                createdBy: globalFilters.filters.createdBy
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
        {globalFilters?.filters?.status?.map(filter => (
          <Badge
            color="bgDefault"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status.filter(f => f.value !== filter.value),
                source: globalFilters.filters.source,
                createdBy: globalFilters.filters.createdBy
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
        {globalFilters?.filters?.createdBy &&
          globalFilters?.filters?.createdBy?.map(filter => (
            <Badge
              color="bgDefault"
              variant="contained"
              key={filter?.value}
              size="sm"
              rounded
              closable
              onClose={() => {
                onFilterChange({
                  status: globalFilters.filters.status,
                  source: globalFilters.filters.source,
                  createdBy: globalFilters.filters.createdBy.filter(f => f.value !== filter.value)
                });
              }}
            >
              {filter?.label}
            </Badge>
          ))}
      </S.SubtitleWrapper>
    )
  );
}

SecondHead.propTypes = {
  globalFilters: PropTypes.shape({
    filters: PropTypes.shape({
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      createdBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    })
  }),
  onFilterChange: PropTypes.func
};

export { SecondHead };
